import { firstNameSchema, lastNameSchema } from '@massilia/features'
import { z } from 'zod'

export const registerSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  firstName: firstNameSchema,
  lastName: lastNameSchema,
  password: z.string().min(1, 'Ce champ est requis'),
})
